export {default} from './global';
